/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { removeBackgroundImage } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import Story from 'material/embeds/content/contenttype/story/story';



/* ========== ~~~~~~~~~~ EMBED : CONTENT : STORY : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => {
    const currentContentState = embedsState.embedManagementState.contentStatus['contents'][contentId];
    const currentContentType = currentContentState.contentType === 'story'? 'story' : 'questionBased';
    return {
        currentContentState,
        isSelected: embedsState.embedManagementState.contentStatus['activeSelection'] === 'background',
        backgroundImageURL: currentContentState[currentContentType]['backgroundImageURL'],
        currentBackgroundImage: currentContentState[currentContentType]['currentBackgroundImage'],
        previewBackgroundImageURL: currentContentState[currentContentType]['previewBackgroundImageURL'],
        backgroundColor: currentContentState[currentContentType]['backgroundColor']
    };
};

const mapDispatchToProps = dispatch => ({
    removeBackgroundImage: contentId => dispatch(removeBackgroundImage(contentId))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Story);
